import React, {useEffect, useState} from 'react';
import styles from "./EditInfluencer.module.scss";
import {Autocomplete, Button, TextField, ToggleButton, ToggleButtonGroup} from "@mui/material";
import {t} from "i18next";
import LinksMultipleChoices from "../AssignInfluencers/LinksMultipleChoices/LinksMultipleChoices";
import {useSelector} from "react-redux";
import {updatePaidProjectInfuencer} from "../../../services/paidProjectsService";
import Toast from "../../../common/toast/Toast";
import useToast from "../../../common/hooks/useToast";
import InfluencerVideos from "./InfluencerVideos";

// ponytail: hardcoded pilot, move to a project flag when more projects need videos
const VIDEO_UPLOAD_PROJECT_IDS = [79];


export const INFLUENCER_PROJECT_STATUS = {
    IN_REVIEW: "In Review",
    APPROVED: "Approved",
    REJECTED: "Rejected"
}


const EditInfluencer = ({infData}) => {

    const [formData, setFormData] = useState(null);
    const projectsData = useSelector((state) => state.projectsList.projects || []);
    const selectedProject = projectsData.find(project => project.id === Number(infData.project_id));
    const {isToastOpen, toggleToast, toastContent, setToastContent} = useToast();
    useEffect(() => {
        setFormData({
            status: infData.status,
            note: infData.note,
            amount: infData.amount,
            links: typeof (infData.links) === 'string' ? JSON.parse(infData.links) : infData.links,
            created_at: infData.created_at,
            name: infData.name
        });
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const [linkInput, setLinkInput] = useState('');
    const addLink = (_, link) => {
        if (!link) return;
        if (!formData.links.includes(link)) setFormData({...formData, links: [...formData.links, link]});
        setLinkInput('');
    }

    const updateInfluenerProjectData = async () => {

        const payload = {
            affId: infData.affiliate_id,
            projectId: infData.project_id,
            status: formData.status,
            links: JSON.stringify(formData.links),
        }
        const response = await updatePaidProjectInfuencer(payload);
        if (!!response.errorCode && !response.data.result) {
            setToastContent(t("common.error_msg"));
        } else {
            setToastContent(t("paid-project.update-influencer-success-msg"));
        }
        toggleToast();
    }


    const removeLink = (link) => {
        if (formData.links.length === 1) return;
        const copyArr = [...formData.links];
        const index = copyArr.indexOf(link);
        if (index > -1) {
            copyArr.splice(index, 1);
        }
        setFormData({...formData, links: copyArr});
    }

    const getFormattedLinks= () => (typeof selectedProject.links === 'string') ?
        JSON.parse(selectedProject.links) :
        selectedProject.links;
    const hasVideos = VIDEO_UPLOAD_PROJECT_IDS.includes(Number(infData.project_id));
    if (!selectedProject || !formData) return null;
    return (
        <div className={`${styles.container} ${hasVideos ? styles.split : ''}`}>
            <section className={styles.pane}>
                <div className={styles.label}>{t('common-en.status')}</div>
                <ToggleButtonGroup exclusive size="small" color="primary" fullWidth value={formData.status}
                                   onChange={(_, status) => status && setFormData({...formData, status})}>
                    {Object.values(INFLUENCER_PROJECT_STATUS).map(status =>
                        <ToggleButton key={status} value={status} className={styles.statusButton}>{status}</ToggleButton>)}
                </ToggleButtonGroup>
                <div className={styles.label}>Links</div>
                <Autocomplete
                    freeSolo
                    size="small"
                    value={null}
                    inputValue={linkInput}
                    onInputChange={(_, v, reason) => reason !== 'reset' && setLinkInput(v)}
                    options={getFormattedLinks()}
                    onChange={addLink}
                    renderInput={(params) => <TextField {...params} placeholder={t('paid-project.select-links')}/>}
                />
                {!!formData.links &&
                    <LinksMultipleChoices startDate={selectedProject.startDate} links={formData.links}
                                          endDate={selectedProject.endDate}
                                          removeLink={removeLink} compact/>}
                <Button variant="contained" size="small" onClick={updateInfluenerProjectData}
                        className={styles.save}>{t('common.update')}</Button>
            </section>
            {hasVideos &&
                <InfluencerVideos projectId={Number(infData.project_id)} affId={infData.affiliate_id}
                                  notify={(msg) => { setToastContent(msg); toggleToast(); }}/>}
            <Toast
                isOpen={isToastOpen}
                onClose={toggleToast}
                content={toastContent}
                severity="info"
            />
        </div>
    );
};

export default EditInfluencer;
